/*
 * @Author: Teemo Ding
 * @Date: 2022-03-24 10:11:11
 * @LastEditTime: 2022-08-04 16:40:52
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/Customer/RecipientInfo.tsx
 */
import { getLockerZones, recipientPage } from '@/src/request/order/createOrder';
import { addressFormat, nameTrans } from '@/src/tools/helper';
import { Icon } from '@/src/tools/icon';
import { useRequest } from 'ahooks';
import { get } from 'lodash';
import React, { Fragment } from 'react';
import ModalHoc from 'src/constrains/ModalHOC';
import { NEW } from 'src/tools/constant';
import { LogisticMethod } from 'src/types/common/logisticMethod';
import EditRecipientInfo from '../EditRecipientInfo';
import { dateOnlyFormat } from 'src/tools/constant';
import css from './css.module.less';
import moment from 'moment';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const RecipientInfo = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    modalOp: { setShowModal, setModalTitle, setModalContent, setWidth },
    customer,
    disabled,
    salesChannelUuid,
    reLoadOrderPage,
    orderUuid,
    buyerInfo,
    recipientInfo,
    languageCode,
    buildData,
    isSubscription,
    setRecipientInfo,
    setBillingAddressDetail,
    customerDetail,
    changeCustomer,
    getRecipientReq,
    saveRecipientReq,
    findCustomerFields,
    products,
    handlGetFees,
    pickupInfo,
  } = props;

  const { recipientEmail, recipientName, recipientPhoneNo, shippingAddress } =
    customerDetail || {};
  const { run: _saveRecipient } = useRequest(
    (data) => saveRecipientReq(orderUuid, data),
    {
      manual: true,
      onSuccess: () => {
        handleCancel();
        if (reLoadOrderPage) reLoadOrderPage();
      },
    },
  );

  //RecipientInfo弹窗
  const { run: _getRecipient } = useRequest(
    () => {
      return customer
        ? recipientPage({
            salesChannelUuid,
            customer,
            products,
            uuid: orderUuid === NEW ? '' : orderUuid,
          })
        : getRecipientReq(orderUuid);
    },
    {
      manual: true,
      onSuccess: (res) => {
        const {
          recipientFields,
          //areaCodes,
          customerInfoFields,
          addressBooks,
          destinations,
          deliveryInfo,
          fullNameAutoPopulate,
          logisticsMethods,
        } = res;
        console.log('res', res);
        setShowModal(true);
        setWidth(600);
        setModalTitle(
          `${getI18n('general.edit')} ${getI18n(
            'allOrders.createneworder.component_customer_RecipientInfo',
          )}`,
        );
        const handleConfirm = (e) => {
          const cbCreat = (data) => {
            const { deliveryInfo, recipientFields: recipientFieldsData } = data;
            const {
              buyerInfoData,
              firstName,
              lastName,
              fullName,
              buyerPhoneNo,
              buyerEmail,
            } = findCustomerFields(
              recipientFieldsData,
              recipientFields,
              'name',
              'name',
              'values',
            );
            const recipient = deliveryInfo.recipient;
            setBillingAddressDetail(data);
            const formatsIndex = (destinations || []).filter(
              (o) => o.format.countryCode == get(recipient, 'countryVO.code'),
            );
            changeCustomer({
              recipientEmail: buyerEmail,
              logisticsMethod: deliveryInfo.logisticsMethod,
              recipientName: nameTrans(
                fullNameAutoPopulate,
                firstName,
                lastName,
                fullName,
              ),
              recipientPhoneNo: buyerPhoneNo,
              shippingAddress:
                deliveryInfo.logisticsMethod == LogisticMethod.Delivery
                  ? addressFormat(
                      get(formatsIndex, [0, 'format', 'fields']),
                      get(data, ['deliveryInfo', 'recipient']),
                    )
                  : '',
            });
            setRecipientInfo({
              deliveryInfo: data.deliveryInfo,
              recipientFields: buyerInfoData,
            });
            handlGetFees({
              deliveryInfo: data.deliveryInfo,
              recipientFields: buyerInfoData,
            });
            handleCancel();
          };
          if (customer) {
            cbCreat(e);
          } else {
            return _saveRecipient(e);
          }
        };
        if (!(!customer && !deliveryInfo)) {
          setModalContent(
            <EditRecipientInfo
              customerInfoFields={
                (buyerInfo || {}).customerInfoFields || customerInfoFields
              }
              onCancel={handleCancel}
              fields={(recipientInfo || {}).recipientFields || recipientFields}
              destinations={destinations}
              addressBooks={addressBooks}
              //areaCodes={areaCodes}
              orderUuid={orderUuid}
              defaultDeliveryInfo={
                customer ? get(recipientInfo, 'deliveryInfo') : deliveryInfo
              }
              logisticsMethods={logisticsMethods}
              languageCode={languageCode}
              getLockerZones={getLockerZones}
              buildData={buildData}
              customer={customer}
              salesChannelUuid={salesChannelUuid}
              isSubscription={isSubscription}
              onConfirm={handleConfirm}
            />,
          );
        }
      },
    },
  );

  const handleCancel = () => {
    setShowModal(false);
    setModalContent('');
  };

  return (
    <Fragment>
      <div className={css.customItem}>
        <h3>
          {getI18n('allOrders.createneworder.component_customer_RecipientInfo')}

          {disabled ? (
            <Icon className={css.disable} type='iconedit' />
          ) : (
            <Icon onClick={_getRecipient} type='iconedit' />
          )}
        </h3>
        <span>{recipientEmail}</span>
        <span>{recipientName}</span>
        <span>{recipientPhoneNo}</span>
      </div>
      {pickupInfo ? (
        <div className={css.customItem}>
          <h3>
            {getI18n('allOrders.createneworder.component_customer_pickinfo')}
          </h3>
          <span> {get(pickupInfo, 'locationName')}</span>
          <span> {get(pickupInfo, 'addressLine')}</span>
          {get(pickupInfo, 'pickupDate') && (
            <span style={{ paddingTop: 16 }}>
              {getI18n('allOrders.createneworder.component_customer_picktime')}
              {moment(get(pickupInfo, 'pickupDate')).format(dateOnlyFormat)}
            </span>
          )}
        </div>
      ) : (
        <div className={css.customItem}>
          <h3>
            {getI18n('allOrders.createneworder.component_customer_shippingadd')}
          </h3>
          {shippingAddress}
        </div>
      )}

      <div className={css.splitLine}></div>
    </Fragment>
  );
};

export default ModalHoc(RecipientInfo);
